<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Settings</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active"> Referral Settings
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4 class="card-title">Referral Settings</h4>
                </div>
                <div class="card-body">
                    <form @submit.prevent="updateReferralSetting">
                        <div class="row">
                            <!-- Signup Points -->
                            <div class="col-6 col-md-4 mb-3">
                                <label for="signup_points" class="form-label">Signup Points</label>
                                <div class="input-group">
                                    <input v-model="setting.signup_points" id="signup_points"
                                           class="form-control" type="number" min="0">
                                </div>
                            </div>

                            <!-- Delivery Points -->
                            <div class="col-6 col-md-4 mb-3">
                                <label for="delivery_points" class="form-label">Delivery Points</label>
                                <div class="input-group">
                                    <input v-model="setting.delivery_points" id="delivery_points"
                                           class="form-control" type="number" min="0">
                                </div>
                            </div>

                            <!-- Amount Per Kilometer (point_value_naira) -->
                            <div class="col-md-4 mb-3">
                                <label for="point_value_naira" class="form-label">Point Value in Naira</label>
                                <div class="input-group">
                                    <span class="input-group-text">₦</span>
                                    <input v-model="setting.point_value_naira" id="point_value_naira"
                                           class="form-control" type="number" step="0.01" min="0">
                                </div>
                            </div>

                            <!-- Minimum Trips for Payout -->
                            <div class="col-6 col-md-3 mb-3">
                                <label for="min_trips_for_payout" class="form-label">Minimum Trips for Payout</label>
                                <div class="input-group">
                                    <input v-model="setting.min_trips_for_payout" id="min_trips_for_payout"
                                           class="form-control" type="number" min="0">
                                </div>
                            </div>

                            <!-- Payout Frequency Trips -->
                            <div class="col-6 col-md-3 mb-3">
                                <label for="payout_frequency_trips" class="form-label">Payout Frequency (Trips)</label>
                                <div class="input-group">
                                    <input v-model="setting.payout_frequency_trips" id="payout_frequency_trips"
                                           class="form-control" type="number" min="0">
                                </div>
                            </div>

                            <!-- Minimum Points for Payout -->
                            <div class="col-6 col-md-3 mb-3">
                                <label for="min_points_for_payout" class="form-label">Minimum Points for Payout</label>
                                <div class="input-group">
                                    <input v-model="setting.min_points_for_payout" id="min_points_for_payout"
                                           class="form-control" type="number" min="0">
                                </div>
                            </div>

                            <!-- Max Referrals per User -->
                            <div class="col-6 col-md-3 mb-3">
                                <label for="max_referrals_per_user" class="form-label">Max Referrals per User</label>
                                <div class="input-group">
                                    <input v-model="setting.max_referrals_per_user" id="max_referrals_per_user"
                                           class="form-control" type="number" min="0">
                                </div>
                            </div>

                            <!-- Referral Enabled (Switch) -->
                            <div class="col-4 mb-3">
                                <div class="form-check form-switch">
                                    <input v-model="setting.is_referral_enabled"
                                           id="is_referral_enabled"
                                           class="form-check-input"
                                           type="checkbox"
                                           :true-value="true"
                                           :false-value="false">
                                    <label class="form-check-label ms-2" for="is_referral_enabled">
                                        Referral System Enabled
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4 col-xs-12">
                                <button class="btn btn-primary" v-if="!saving">update</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {VueEditor} from "vue2-editor";
import ValidationErrors from "../../Shared/ValidationErrors";

export default {
    metaInfo: {title: 'Referral Setting'},
    name: 'ReferralSettingIndex',
    props: ['settingsData'],
    components: {
        VueEditor,
        ValidationErrors
    },
    layout: Layout,
    data() {
        return {
            saving: false,
            setting: [],
        }
    },
    methods: {
        async updateReferralSetting() {
            this.saving = true;
            this.$inertia.put(route('admin.settings.referral.update'), {...this.setting}, {
                preserveScroll: true,
                onSuccess: () => this.saving = false,
                onError: () => {
                    this.saving = false;
                }
            });
        }
    },
    created() {
        let data = Object.keys(this.settingsData);
        if (data.length) {
            this.setting.signup_points = this.settingsData.signup_points;
            this.setting.delivery_points = this.settingsData.delivery_points;
            this.setting.point_value_naira = this.settingsData.point_value_naira;
            this.setting.min_trips_for_payout = this.settingsData.min_trips_for_payout;
            this.setting.payout_frequency_trips = this.settingsData.payout_frequency_trips;
            this.setting.min_points_for_payout = this.settingsData.min_points_for_payout;
            this.setting.is_referral_enabled = this.settingsData.is_referral_enabled !== "0";
            this.setting.max_referrals_per_user = this.settingsData.max_referrals_per_user;
        }
    },
}
</script>
